import React, { Fragment } from 'react'
import MEModal from '../../components/MEModal'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  Button,
  MenuItem,
} from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { removeSection } from '../actions'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

class RemoveSectionModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      editedSectionName: '',
      removeSectionModalOpen: false,
      removeSectionId: '',
      sectionSelected: false,
    }
    this.toggleRemoveSectionModal = this.toggleRemoveSectionModal.bind(this)
    this.handleRemoveSectionName = this.handleRemoveSectionName.bind(this)
    this.submitRemoveSection = this.submitRemoveSection.bind(this)
  }

  toggleRemoveSectionModal() {
    this.setState({
      removeSectionModalOpen: !this.state.removeSectionModalOpen,
    })
  }

  handleRemoveSectionName(e) {
    let sectionSelected = false
    if (!isNaN(e.target.value)) {
      sectionSelected = true
    } else {
      sectionSelected = false
    }
    this.setState({
      removeSectionId: e.target.value,
      sectionSelected: sectionSelected,
    })
  }

  async submitRemoveSection() {
    let data = this.props.filters
    data.section_id = this.props.section
    data.section_destination_id = this.state.removeSectionId
    data.pageNum = this.props.currentCourseMemPage
    data.archivedPageNum = this.props.currentArchivePage
    this.toggleRemoveSectionModal()
    let response = await this.props.removeThisSection(data)
    if (response.status === 200) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Section Removed"
            content="Successfully removed the section."
            scheme={Cinnamon.Crisp.SCHEME_GREY}
          />
        ),
      })
    } else {
      let error = response.error
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content={error}
            scheme={Cinnamon.Crisp.SCHEME_RED}
          />
        ),
      })
    }
  }

  render() {
    return (
      <Fragment>
        {this.props.allSectionData.length > 1 && (
          <MenuItem
            onClick={this.toggleRemoveSectionModal}
            className="me-list-item"
          >
            <div className="fal fa-minus-circle mr-2 fa-fw color_teal" />
            Remove Section
          </MenuItem>
        )}
        <MEModal
          show={this.state.removeSectionModalOpen}
          close={this.toggleRemoveSectionModal}
          title="Remove Section"
        >
          <form onSubmit={e => e.preventDefault()}>
            <p>
              This will permanently remove section {this.props.sectionName}.
            </p>
            <FormGroup>
              <ControlLabel>Move those in this section to:</ControlLabel>
              <FormControl
                componentClass="select"
                placeholder="select"
                onChange={this.handleRemoveSectionName}
              >
                <option>- Select Section -</option>
                {this.props.allSectionData
                  .filter(r => r.secName !== this.props.sectionName)
                  .map((r, key) => (
                    <option key={key} value={r.id}>
                      {r.secName}
                    </option>
                  ))}
              </FormControl>
            </FormGroup>
            {this.state.sectionSelected ? (
              <div className="text-center">
                <Button
                  type="button"
                  bsStyle="primary"
                  className="btn-myed btn-primary-myed"
                  onClick={this.submitRemoveSection}
                >
                  Submit
                </Button>
              </div>
            ) : null}
          </form>
        </MEModal>
      </Fragment>
    )
  }
}

RemoveSectionModal.propTypes = {
  section: PropTypes.string,
  allSectionData: PropTypes.array,
  sectionName: PropTypes.string,
  removeThisSection: PropTypes.func,
  sectionData: PropTypes.array,
  filters: PropTypes.object,
}

const mapStateToProps = state => {
  return {
    allSectionData: state.allSectionData,
    filters: state.filters,
    currentCourseMemPage: state.currentCourseMemPage,
    currentArchivePage: state.currentArchivePage,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    removeThisSection: sectionData => {
      let response = dispatch(removeSection(sectionData))
      return response
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RemoveSectionModal)
